var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04102 27.125C8.3306 27.125 7.72244 26.872 7.21654 26.3661C6.71063 25.8602 6.45768 25.2521 6.45768 24.5417V7.75H5.16602V5.16667H11.6243V3.875H19.3743V5.16667H25.8327V7.75H24.541V24.5417C24.541 25.2521 24.2881 25.8602 23.7822 26.3661C23.2763 26.872 22.6681 27.125 21.9577 27.125H9.04102ZM21.9577 7.75H9.04102V24.5417H21.9577V7.75ZM11.6243 21.9583H14.2077V10.3333H11.6243V21.9583ZM16.791 21.9583H19.3743V10.3333H16.791V21.9583Z",
    fill: "#E06262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.6658ec705eb1510102bec245450aeb14.svg";
export { ForwardRef as ReactComponent };